import { translate } from '@utilities/helpers/core.helpers'

export const gfGetRequiredFieldMessage = field => {
  const fallback = translate('FORM_FIELD_REQUIRED')
  const hasTranslation = translate('FORM_FIELD_REQUIRED')

  if (hasTranslation) {
    return hasTranslation
  } else {
    return fallback
  }
}
